import { render, staticRenderFns } from "./SendMessageSelectModal.vue?vue&type=template&id=28fa38c2&lang=pug"
import script from "./SendMessageSelectModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageSelectModal.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageSelectModal.vue?vue&type=style&index=0&id=28fa38c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports